<template>
  <PageModal
    :modal-id
    :title="title"
    :text="
      $texts('languagePopup.text')
    "
  >
    <ul class="mt-4">
      <li v-for="link in links" :key="link.code">
        <ZtLink :to="link.url" class="link text-prose">
          <SpriteSymbol name="language-switch" />
          <span>{{ link.label }}</span>
        </ZtLink>
      </li>
    </ul>
  </PageModal>
</template>

<script setup lang="ts">
import { LANGUAGE_LABEL } from '~/helpers/locale'

const { $texts } = useEasyTexts()

const props = defineProps<{
  currentLanguage: string
  alternatives: Record<string, string>
}>()

const { modalId, openModal } = useModal('language-popup')

openModal()

const LANGUAGE_LABELS_IN_TEXT: Record<string, string> = {
  de: 'Deutsch',
  en: 'English',
  fr: 'français',
  it: 'italiano',
}

const links = computed(() => {
  return Object.entries(props.alternatives).map(([code, url]) => {
    return {
      code,
      url,
      label: LANGUAGE_LABEL[code],
    }
  })
})

const title = computed(() => {
  const languageLabel =
    LANGUAGE_LABELS_IN_TEXT[props.currentLanguage] || props.currentLanguage
  return $texts('languagePopup.title').replace('@language', languageLabel)
})
</script>
